import React, { useContext } from 'react';
import * as Styled from './ImageCarouselSelector.styled';
import { ContainerQueryContext } from '../../../../util/ContainerQuery.context';
/**
 * Component that renders a controller to navigate the Carousel
 */
var ImageCarouselSelector = function (_a) {
    var className = _a.className, currentSlide = _a.currentSlide, totalSlides = _a.totalSlides, onIndicatorClick = _a.onIndicatorClick, onInfiniteLoop = _a.onInfiniteLoop, onLeftArrowClick = _a.onLeftArrowClick, onRightArrowClick = _a.onRightArrowClick;
    var styleQueryMode = useContext(ContainerQueryContext).styleQueryMode;
    return (React.createElement(Styled.ImageCarouselSelector, { className: className, "$styleQueryMode": styleQueryMode },
        React.createElement(Styled.ButtonIcon, { variant: "link", name: "arrow-left", "aria-label": "arrow-left", "data-label": "productCard_carouselArrow", iconSize: "inherit", isRounded: false, isDisabled: !onInfiniteLoop && currentSlide === 1, onClick: function () {
                if (currentSlide === 1 && onInfiniteLoop) {
                    onInfiniteLoop('previous');
                }
                else {
                    onLeftArrowClick();
                }
            }, "$styleQueryMode": styleQueryMode }),
        React.createElement(Styled.PageIndicatorContainer, null, Array.from({ length: totalSlides }).map(function (_, index) { return (React.createElement(Styled.PageIndicator, { key: index, className: "div", isSelected: currentSlide - 1 === index, onClick: onIndicatorClick(index), "data-label": "productCard_carouselIndicator" })); })),
        React.createElement(Styled.ButtonIcon, { variant: "link", name: "arrow-right", "aria-label": "arrow-right", "data-label": "productCard_carouselArrow", iconSize: "inherit", isRounded: false, isDisabled: !onInfiniteLoop && currentSlide === totalSlides, onClick: function () {
                if (currentSlide === totalSlides && onInfiniteLoop) {
                    onInfiniteLoop('next');
                }
                else {
                    onRightArrowClick();
                }
            }, "$styleQueryMode": styleQueryMode })));
};
export default ImageCarouselSelector;
